unit View.Modulos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewModulosList = class(TForm)
    btNew: TButton;
    ModulosDataset: TXDataWebDataSet;
    ModulosDatasetid: TIntegerField;
    ModulosDatasetnome: TStringField;
    ModulosDatasetcodigo_interno: TIntegerField;
    ModulosDatasetexcluido: TBooleanField;
    ModulosDatasetinclusao: TDateTimeField;
    ModulosDatasetalteracao: TDateTimeField;
    ModulosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewModulosList: TFViewModulosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewModulosList }

procedure TFViewModulosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewModulosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewModulosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewModulosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewModulosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewModulosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewModulosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ModulosDataset.Connection.Model.DefaultSchema.FindEntityType(ModulosDataset.EntitySetName),
      ModulosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewModulosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('modulos', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    ModulosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewModulosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.modulos.list.pagination.info');
  btNew := TButton.Create('view.modulos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.modulos.list.table');
  cbPageSize := TComboBox.Create('view.modulos.list.cbPageSize');
  edSearch := TEdit.Create('view.modulos.list.search');
  lcPaginator := TListControl.Create('view.modulos.list.pagination');
  ModulosDataset := TXDataWebDataSet.Create(Self);
  ModulosDatasetid := TIntegerField.Create(Self);
  ModulosDatasetnome := TStringField.Create(Self);
  ModulosDatasetcodigo_interno := TIntegerField.Create(Self);
  ModulosDatasetexcluido := TBooleanField.Create(Self);
  ModulosDatasetinclusao := TDateTimeField.Create(Self);
  ModulosDatasetalteracao := TDateTimeField.Create(Self);
  ModulosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ModulosDataset.BeforeLoadDFMValues;
  ModulosDatasetid.BeforeLoadDFMValues;
  ModulosDatasetnome.BeforeLoadDFMValues;
  ModulosDatasetcodigo_interno.BeforeLoadDFMValues;
  ModulosDatasetexcluido.BeforeLoadDFMValues;
  ModulosDatasetinclusao.BeforeLoadDFMValues;
  ModulosDatasetalteracao.BeforeLoadDFMValues;
  ModulosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewModulosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    ModulosDataset.SetParentComponent(Self);
    ModulosDataset.Name := 'ModulosDataset';
    ModulosDataset.EntitySetName := 'Modulos';
    ModulosDataset.Connection := DMConnection.ApiConnection;
    ModulosDataset.Left := 72;
    ModulosDataset.Top := 144;
    ModulosDatasetid.SetParentComponent(ModulosDataset);
    ModulosDatasetid.Name := 'ModulosDatasetid';
    ModulosDatasetid.FieldName := 'id';
    ModulosDatasetid.Required := True;
    ModulosDatasetnome.SetParentComponent(ModulosDataset);
    ModulosDatasetnome.Name := 'ModulosDatasetnome';
    ModulosDatasetnome.FieldName := 'nome';
    ModulosDatasetnome.Size := 255;
    ModulosDatasetcodigo_interno.SetParentComponent(ModulosDataset);
    ModulosDatasetcodigo_interno.Name := 'ModulosDatasetcodigo_interno';
    ModulosDatasetcodigo_interno.FieldName := 'codigo_interno';
    ModulosDatasetcodigo_interno.Required := True;
    ModulosDatasetexcluido.SetParentComponent(ModulosDataset);
    ModulosDatasetexcluido.Name := 'ModulosDatasetexcluido';
    ModulosDatasetexcluido.FieldName := 'excluido';
    ModulosDatasetinclusao.SetParentComponent(ModulosDataset);
    ModulosDatasetinclusao.Name := 'ModulosDatasetinclusao';
    ModulosDatasetinclusao.FieldName := 'inclusao';
    ModulosDatasetalteracao.SetParentComponent(ModulosDataset);
    ModulosDatasetalteracao.Name := 'ModulosDatasetalteracao';
    ModulosDatasetalteracao.FieldName := 'alteracao';
    ModulosDatasetexclusao.SetParentComponent(ModulosDataset);
    ModulosDatasetexclusao.Name := 'ModulosDatasetexclusao';
    ModulosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ModulosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ModulosDataset.AfterLoadDFMValues;
    ModulosDatasetid.AfterLoadDFMValues;
    ModulosDatasetnome.AfterLoadDFMValues;
    ModulosDatasetcodigo_interno.AfterLoadDFMValues;
    ModulosDatasetexcluido.AfterLoadDFMValues;
    ModulosDatasetinclusao.AfterLoadDFMValues;
    ModulosDatasetalteracao.AfterLoadDFMValues;
    ModulosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
